import { useScheduleActionsContext } from "../contexts/ScheduleActions";

import { alertActions } from "../../../../../features/alert/alertSlice";
import { selectSelectedTournament } from "../../../../../features/tourneymgmt/tournamentManagementSlice";
import {
    useAppDispatch,
    useAppSelector,
} from "../../../../../hooks/reduxHooks";
import { runScheduleActions } from "../../../../../lib/api";
import { IMasterTournament } from "../../../../../types/api";

export const useFormHandlers = () => {
    const dispatch = useAppDispatch();
    const tournament = useAppSelector(
        selectSelectedTournament,
    ) as IMasterTournament;
    const {
        daysToMove,
        moveGamesFromField,
        moveGamesToField,
        adjustStartTimesGames,
        adjustStartTimesAmount,
        adjustGameLengthsGames,
        adjustGameLengthsAmount,
        setDaysToMove,
        setMoveGamesFromField,
        setMoveGamesToField,
        setSchedule,
        setFetchStatus,
        setMoveGamesDays,
        setAdjustStartTimesDayToAdjust,
        setAdjustStartTimesDays,
        setAdjustStartTimesField,
        setAdjustStartTimesGames,
        setAdjustStartTimesAmount,
        setAdjustGameLengthsDayToAdjust,
        setAdjustGameLengthsDays,
        setAdjustGameLengthsField,
        setAdjustGameLengthsGames,
        setAdjustGameLengthsAmount,
    } = useScheduleActionsContext();

    const onSubmit = async () => {
        setFetchStatus("pending");
        await runScheduleActions(tournament?.id, {
            daysToMove,
            moveGamesFromField,
            moveGamesToField,
            adjustStartTimesGames,
            adjustStartTimesAmount,
            adjustGameLengthsGames,
            adjustGameLengthsAmount,
        })
            .then(response => {
                setFetchStatus("success");
                dispatch(
                    alertActions.success({
                        title: `The schedule was updated successfully.`,
                        dismissible: true,
                    }),
                );
                setDaysToMove([]);
                setMoveGamesFromField(undefined);
                setMoveGamesToField(undefined);
                setMoveGamesDays([]);
                setAdjustStartTimesDayToAdjust(undefined);
                setAdjustStartTimesDays([]);
                setAdjustStartTimesField(undefined);
                setAdjustStartTimesGames([]);
                setAdjustStartTimesAmount(undefined);
                setAdjustGameLengthsDayToAdjust(undefined);
                setAdjustGameLengthsDays([]);
                setAdjustGameLengthsField(undefined);
                setAdjustGameLengthsGames([]);
                setAdjustGameLengthsAmount(undefined);
                setSchedule(response.schedule);
            })
            .catch(e => {
                setFetchStatus("failed");
                dispatch(
                    alertActions.error({
                        title: `The server encountered a problem updating the tournament.`,
                        text: "If the problem continues, please reach out to an admin.",
                        dismissible: true,
                    }),
                );
            });
    };

    return { onSubmit };
};
